<template>
  <div class="bg-thumbnail" :style="bannerStyle"></div>
</template>
<script>
export default {
  props: ["url"],
  computed: {
    bannerStyle() {
      if (this.url) return `background-image: url('${this.url}');`;

      return "";
    }
  }
};
</script>
<style lang="scss" scoped>
.bg-thumbnail {
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;

  background-color: #000;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  opacity: 1;

  transition: opacity 0.6s ease-in-out;
}
</style>
